import React, { useRef } from 'react';
import { useOnClickOutside } from 'utils/hooks';

const ClickOutside = ({
  children,
  onClickOutside,
}: {
  children: React.ReactNode;
  onClickOutside: (event: MouseEvent | TouchEvent) => void;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, onClickOutside);

  return <div ref={ref}>{children}</div>;
};

export default ClickOutside;
